import { useMemo } from 'react';
import { Link } from 'react-router-dom';

import { IKnmSearchClipped } from 'APIPackage/KnmSearchModule/interfaces/IKnmSearchClipped';
import { ROUTE_KNM_PREVIEW_BY_ID } from 'CorePackage/MainModule/routes/routes';
import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

interface ISearchKnmTableCellProps {
  row: IKnmSearchClipped;
  id: ITableColumn<IKnmSearchClipped>['id'];
}

export const SearchKnmTableCell = ({ row, id }: ISearchKnmTableCellProps) => {
  const getJsonValue = (value: string): { title?: string; fullName?: string } | string => {
    try {
      return JSON.parse(value);
    } catch (err) {
      return value;
    }
  };

  const cellValue: JSX.Element | string | undefined = useMemo(() => {
    if (id === 'number') {
      return (
        <Link className="shared-table-link" to={ROUTE_KNM_PREVIEW_BY_ID(row.id)} target="_blank">
          {row[id]}
        </Link>
      );
    }

    const frguOrgFullName = getJsonValue(row.frguOrgName || row.frguOrgFullName);

    if (frguOrgFullName && id === 'frguOrgName') {
      return typeof frguOrgFullName === 'object' ? frguOrgFullName.fullName : frguOrgFullName;
    }

    const knmType = getJsonValue(row.knmType);

    if (knmType && id === 'knmType') {
      return typeof knmType === 'object' ? knmType.title : knmType;
    }

    if (row.federalLaw && id === 'federalLaw') {
      return `${row.federalLaw}-ФЗ`;
    }

    const carryoutName = getJsonValue(row.carryoutName);

    if (carryoutName && id === 'carryoutName') {
      return typeof carryoutName === 'object' ? carryoutName.title : carryoutName;
    }

    return row[id];
  }, [row, id]);

  return cellValue || '';
};
